"use strict";

var vm = new Vue({
    el: "#priceguide-app",
    data: {
        isMember: false,
        selectedYear: "",
        code: "",
        showSearchForm: false,
        selectedMake: "",
        selectedModel: "",
        showError: "",
        years: [],
        makes: [],
        models: [],
        loading: true,
        searchInputYear: "",
        priceResult: "",
        priceSearchLoading: false,
        cond: 0
    },

    methods: {
        getModels: function getModels(make) {
            var _this = this;

            this.selectedMake = make;
            this.clearResult();
            var getUrl = "/priceguide/getModels?year=" + this.selectedYear + "&make=" + this.selectedMake;
            axios.get(getUrl).then(function (res) {
                _this.models = res.data;
            }).catch(function (error) {
                _this.showError = true;
            });
        },
        getMakes: function getMakes(year) {
            var _this2 = this;

            this.selectedYear = year;
            this.selectedMake = "Velg merke";
            this.selectedModel = "Velg model";
            this.clearResult();
            var getUrl = "/priceguide/getmakes?year=" + this.selectedYear;
            axios.get(getUrl).then(function (res) {
                _this2.makes = res.data;
            }).catch(function (error) {
                _this2.showError = true;
            });
        },
        getPrice: function getPrice(model) {
            var _this3 = this;

            this.clearResult();
            this.selectedModel = model;
            this.priceSearchLoading = true;

            var priceSearchUrl = "/priceguide/getpriceforcar?year=" + encodeURIComponent(this.selectedYear) + "&make=" + encodeURIComponent(this.selectedMake) + "&model=" + encodeURIComponent(this.selectedModel);

            axios.get(priceSearchUrl).then(function (res) {
                _this3.priceResult = res.data.price;
                _this3.priceSearchLoading = false;
            }).catch(function (err) {
                console.log(err);
            });
        },
        clearResult: function clearResult() {
            this.showError = false;
            this.loading = false;
            this.priceResult = "";
        },
        runTeaser: function runTeaser() {
            var teaserTimeout = void 0;
            var target = $('#amcarTeaserSection');

            teaserTimeout = setTimeout(function (event) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }, 10000);

            $(window).on('scroll', function (event) {
                clearTimeout(teaserTimeout);
            });
        },
        showInfoText: function showInfoText(cond) {
            this.cond = cond;

            var target2 = $('#condtext');
            $('html, body').animate({
                scrollTop: target2.offset().top
            }, 500);
        }
    },

    mounted: function mounted() {
        var _this4 = this;

        axios.get("/priceguide/getUserSearchInfo/").then(function (res) {
            _this4.loading = false;
            var data = res.data;
            if (data.isMember) {
                _this4.isMember = true;
                axios.get("/priceguide/getyears").then(function (res) {
                    _this4.years = res.data;
                }).catch(function (res) {
                    _this4.showError = true;
                });
            } else {
                _this4.priceResult = {
                    excellent: "500 000",
                    fair: "350 000",
                    good: "450 000"
                };

                _this4.makes.push("Ford");
                _this4.models.push("Mustang Shelby GT500 Coupe");
                _this4.years.push("2007");

                _this4.selectedMake = "Ford";
                _this4.selectedModel = "Mustang Shelby GT500 Coupe";
                _this4.selectedYear = "2007";
            }
            _this4.showSearchForm = true;
        }).catch(function (err) {
            console.log(err);
        });
    }
});

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}